import appStore from 'store';
import api from './api';

const store = {
	namespaced: true,
	state: {
		listData: [],   //nft列表
		pagination: {
			page: 1,
			size: 10
		},
		total: 0
	},
	getters: {

	},
	mutations: {
		setList(state, data) {
			state.listData = data;
		},
		setPagination(state, payload) {
			state.pagination = payload
		},
		setTotal(state, payload) {
			state.total = payload
		}
	},
	actions: {
		//列表
		getNFTListA({ commit }, data) {
			api.getNFTList(data).then(res => {
				let records = res.data.records;
				records.forEach(item => {
					item.rewardName = item.rewardName ? JSON.parse(item.rewardName) : ""
					item.creator = item.creator ? JSON.parse(item.creator) : ""
					item.describeInfo = item.describeInfo ? JSON.parse(item.describeInfo) : ""
					item.nameObj = Object.keys(item.rewardName).map(v => ({ lang: v, name: item.rewardName[v] }))
					item.creatorObj = Object.keys(item.creator).map(v => ({ lang: v, name: item.creator[v] }))
					item.descObj = Object.keys(item.describeInfo).map(v => ({ lang: v, name: item.describeInfo[v] }))
				});
				commit('setList', records);
				commit('setTotal', res.data.total)
				commit('setPagination', { page: data.page, size: data.size })
			});
		},

	}
};
appStore.registerModule('nft', store);
